import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AlertModal } from 'src/app/model/alert';
import { QuoteDataCaptureService, UtilService, ApplicationDataCaptureService, SERVICE_END_POINT, AnalyticsService, FormValidationsService } from '../../shared';
import { AppState } from 'src/app/store/state/app.state';
import { Observable } from 'rxjs';
import { RefNo } from 'src/app/model/ngrx';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { SaveReturnModel, InvalidCtlNameObj } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { UntypedFormGroup } from '@angular/forms';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ModalComponent } from '../modal/modal.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-save',
    templateUrl: './save.component.html',
    styleUrls: ['./save.component.scss'],
    imports: [NgClass, ModalComponent]
})
export class SaveComponent implements OnInit {
  @Input() location: any;
  @Input() saverAndReturnObj: SaveReturnModel;
  @Input() parentFormToValidate: UntypedFormGroup;
  @Input() parentFormToJustToClear: UntypedFormGroup;
  @Input() parentElement: ElementRef;
  @Input() cdRefParent: ChangeDetectorRef;
  @Input() emitInvalidEvtFlag: boolean;
  contentData: object;
  protected cmsData1;
  loginDetail: any;
  displayAlert: any;
  saveAlertWithoutLogin: any;
  saveProgressLabel: string;
  public alertLoginModalConfig: AlertModal;
  public alertAnonymousModalConfig: AlertModal;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  isLocked: boolean = false;
  public lockedAlertModalConfig: AlertModal;
  private CMSData;
  CMSDataAnonUser;
  CMSDataLoggedUser;
  screenName;
  private Label;
  @Output() closeSaveModal = new EventEmitter();

  constructor(private route: ActivatedRoute,
    private router: Router,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private applicationDataCaptureService: ApplicationDataCaptureService,
    private store: Store<AppState>,
    private utilService: UtilService,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private analyticsService: AnalyticsService) {
    this.contentData = this.route.snapshot.data.contentData;
    this.cmsData1 = this.route.snapshot.data.contentData.contentTopNavigationBar;
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    this.saveProgressLabel = this.toggleLabel();
    this.referenceNumberStore = store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
      } else {
        this.referenceNumber = null;
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.GetCMSDataServiceMapperLoggedInUser();
    this.alertAnonymousModalConfig = this.contentData['saveProgressModalConfig'].saveModalConfigAnonymousUser;
    // tslint:disable-next-line:max-line-length
    this.alertLoginModalConfig = this.loginDetail && this.loginDetail.customer.registrationStatus ? this.contentData['saveProgressModalConfig'].saveModalConfigLoginUser : this.alertAnonymousModalConfig;
    this.lockedAlertModalConfig = this.contentData['modalConfigLocked'];
  }

  scrollInvalidForm() {
    if (this.parentElement) {
      setTimeout(() => {
        const invalidElements = this.parentElement.nativeElement.querySelectorAll('.form-validation-error');
        if (invalidElements.length > 0) {
          invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }
      }, 0);
    }
  }

  saveProgress() {
    this.trackAnalytics();
    this.clearFormErrors();
    this.runChangeDetection();
    this.handleInvalidForm();
    if (this.router.url === '/apply/your-pension-savings') {
      this.applicationDataCaptureService.onSave();
      return;
    } else if (this.router.url.substr(1, 5) === 'apply') {
      // Makes save call for Apply Journey
      this.applicationDataCaptureService.onSave();
      this.displayAlert = true;
      this.saveAlertWithoutLogin = true;
    } else {
      this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
        res => {
          if (res && !this.router.url.includes('ho-underwriting')) {
            this.isLocked = true;
          } else {
            this.isLocked = false;
            this.quoteDatacaptureService.onSave();
            this.displayAlert = true;
            this.saveAlertWithoutLogin = true;
          }
        }
      );
    }
  }

  trackAnalytics() {
    if (!this.router.url.includes('medical-condition-questionnaire')) {
      const isAuthenticated = !!this.loginDetail?.customer?.registrationStatus;
      const name = isAuthenticated ? 'Quote save - authenticated' : 'Quote save - non - authenticated';
      this.analyticsService.eventTrack({ type: 'Lightbox', name, position: this.getCurrentScreenURL()});
    }
  }
  clearFormErrors() {
    FormValidationsService.clearFormErrors(this.parentFormToValidate);
    FormValidationsService.clearFormErrors(this.parentFormToJustToClear);
  }
  runChangeDetection() {
    if (this.cdRefParent && !(this.cdRefParent as ViewRef).destroyed) {
      this.cdRefParent.detectChanges();
    }
  }
  handleInvalidForm() {
    let invalidDataObj: InvalidCtlNameObj = FormValidationsService.isInvalidDataFoundInForm(this.parentFormToValidate);
    if (invalidDataObj && invalidDataObj.invalidDataPresent) {
      if (this.emitInvalidEvtFlag) {
        this.utilService.emitInvalidMessageEvt(invalidDataObj);
      }
      else {
        FormValidationsService.validateAllFormForOneCtl(this.parentFormToValidate, invalidDataObj.ctlName);
        this.scrollInvalidForm();
      }
      return;
    }
  }
  alertPrimaryBtnClick() {
    if (this.loginDetail && this.loginDetail.customer.registrationStatus) {
      this.quoteDatacaptureService.onSave();
      this.router.navigate(['/quote/your-saved-quotes']);
    } else {
      this.displayAlert = false;
      this.saveAlertWithoutLogin = false;
      this.closeSaveModal.emit();
    }
  }
  alertSecondaryBtnClick() {
    this.router.navigate(['/home/registration']);
  }
  closeModal() {
    this.displayAlert = false;
    this.saveAlertWithoutLogin = false;
    this.closeSaveModal.emit();
  }
  toggleLabel(): string {
    let tempLabel: string;
    if (
      this.router.url.indexOf(MEDICAL_UW_URL.annuitant.AMC) > -1 || this.router.url.indexOf(MEDICAL_UW_URL.dependant.dependantAMC) > -1 ||
      // tslint:disable-next-line: max-line-length
      this.router.url.indexOf(MEDICAL_UW_HO_URL.annuitant.AMC) > -1 || this.router.url.indexOf(MEDICAL_UW_HO_URL.dependant.dependantAMC) > -1 ||
      // tslint:disable-next-line: max-line-length
      this.router.url.indexOf(MEDICAL_UW_URL.annuitant.diabetes) > -1 || this.router.url.indexOf(MEDICAL_UW_URL.dependant.dependantDiabetes) > -1 ||
      // tslint:disable-next-line: max-line-length
      this.router.url.indexOf(MEDICAL_UW_HO_URL.annuitant.diabetes) > -1 || this.router.url.indexOf(MEDICAL_UW_HO_URL.dependant.dependantDiabetes) > -1 ||
      this.router.url.includes(MEDICAL_UW_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_URL.dependant.dependantDMC) ||
      // tslint:disable-next-line: max-line-length
      this.router.url.includes(MEDICAL_UW_HO_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_HO_URL.dependant.dependantDMC)
    ) {
      tempLabel = this.cmsData1.saveReturn;
      return tempLabel;
      // tslint:disable-next-line: max-line-length
    } else if (
      // tslint:disable-next-line: max-line-length
      this.router.url === MEDICAL_UW_URL.annuitant.medicalConditions || this.router.url === MEDICAL_UW_URL.dependant.dependantMedicalConditions ||
      // tslint:disable-next-line: max-line-length
      this.router.url === MEDICAL_UW_HO_URL.annuitant.medicalConditions || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions ||
      this.router.url === MEDICAL_UW_URL.annuitant.ADL || this.router.url === MEDICAL_UW_URL.dependant.dependantADL ||
      this.router.url === MEDICAL_UW_HO_URL.annuitant.ADL || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantADL ||
      this.router.url === MEDICAL_UW_URL.annuitant.doctorDetails || this.router.url === MEDICAL_UW_URL.dependant.dependantDoctorDetails ||
      // tslint:disable-next-line: max-line-length
      this.router.url === MEDICAL_UW_HO_URL.annuitant.doctorDetails || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantDoctorDetails) {
      tempLabel = this.cmsData1.saveProgress;
      return tempLabel;
    } else {
      tempLabel = this.cmsData1.saveProgress;
      return tempLabel;
    }
  }
  closeLockedModal() {
    this.isLocked = false;
    this.closeSaveModal.emit();
  }
  /** Code block for CMS */

  CMSContentMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_HeaderAndFooter;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSData = res;
      if (this.CMSData) {
        /** This method should only be called once CMSData != null */
        this.cmsData1.saveProgress = this.CMSData.commonBlock.string_SaveProgressCTALabel;
        this.Label = this.CMSData.commonBlock.string_SaveProgressCTALabel;
        if (this.router.url.includes(MEDICAL_UW_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_URL.dependant.dependantDMC)) {
          this.cmsData1.saveProgress = this.CMSData.string_ReturnMedicalCondsCTALabel;
        }
      }
    });
  }
  getLabel() {
    if (this.CMSData) {
      return this.cmsData1.saveProgress;
    }
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_ShortModal_SavedNotLoggedIn;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSDataAnonUser = res;
      if (this.CMSDataAnonUser) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData['saveProgressModalConfig'].saveModalConfigAnonymousUser.header = this.CMSDataAnonUser.string_LoginPopUpMessageTitle;
        this.contentData['saveProgressModalConfig'].saveModalConfigAnonymousUser.content = this.CMSDataAnonUser.string_LoginPopUpMessageText;
        this.contentData['saveProgressModalConfig'].saveModalConfigAnonymousUser.footerPrimaryBtnLabel = this.CMSDataAnonUser.string_LoginPopUpLoginCTALabel;
      }
    });
  }

  GetCMSDataServiceMapperLoggedInUser() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_ShortModal_SavedLoggedIn;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSDataLoggedUser = res;
      if (this.CMSDataLoggedUser) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */

        this.contentData['saveProgressModalConfig'].saveModalConfigLoginUser.header = this.CMSDataLoggedUser.string_SavedPopUpMessageLoggedInTitle;
        this.contentData['saveProgressModalConfig'].saveModalConfigLoginUser.content = this.CMSDataLoggedUser.string_SavedPopUpMessageLoggedInText1;
        this.contentData['saveProgressModalConfig'].saveModalConfigLoginUser.footerPrimaryBtnLabel = this.CMSDataLoggedUser.string_SavedPopUpLoggedInCTALabel1;
        this.contentData['saveProgressModalConfig'].saveModalConfigLoginUser.checkMessage = this.CMSDataLoggedUser.string_SavedPopUpLoggedInCTALabel2;
        /** For Apply */
        if (this.router.url.includes('/apply')) {
          this.contentData['saveProgressModalConfig'].saveModalConfigLoginUser.checkMessage = this.CMSDataLoggedUser.string_SavedPopUpLoggedInCTALabel3;
        }

      }
    });
  }
  /** End of code block for CMS */
  /** For web tracking */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

    return this.screenName;
  }
}
